import { Colors as e } from "../colors/index.js";
import { buildColorsCSSVariables as a } from "./colors.js";
const r = {
  colors: {
    Alpha: e.Ice,
    Bravo: e.Graphite,
    Charlie: e.Graphite,
    Delta: e.Graphite,
    Eco: e.RedNinja,
    FoxTrot: e.Bittersweet,
    Golf: e.Graphite,
    Hotel: e.Graphite,
    India: e.Coal,
    Juliet: e.Coal,
    Kilo: e.Black,
    Lima: e.YourPink,
    // Exceptions -> Use only when standard colors are not sufficient, and the project design indicates that it is an exception.
    Mike: e.Graphite,
    November: e.Gray,
    Oscar: e.Black,
    Papa: e.Graphite,
    Quebec: e.Black,
    Romeu: e.Graphite,
    Sierra: e.Graphite,
    Tango: e.Graphite,
    Uniform: e.Graphite,
    Victor: e.White,
    Whiskey: e.Silver,
    // Exceptions
    XRay: e.Ice,
    Yankee: e.RedNinja,
    Zulu: e.Bittersweet,
    AlphaAlpha: e.Bittersweet,
    BravoBravo: e.White,
    // Brand theme
    Brand: e.RedNinja
  }
}, t = a(
  r.colors
);
export {
  r as DarkNinjaTheme,
  t as DarkNinjaThemeColorsCSSVariables
};
